import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {VersionCheckService} from "./core/versions/version-check.service";
import {Router, RouterOutlet} from '@angular/router';
import {ImagePreviewData, ImagePreviewService} from "./shared/service/image/image-preview.service";
import {Subscription} from "rxjs";
import {ImagePreviewModalComponent} from "./shared/components/image-preview-modal/image-preview-modal.component";

import {DiscountService} from "./apps/subscriptions/shared/service/discount.service";
import {NgProgressbar} from "ngx-progressbar";
import {NgProgressRouter} from "ngx-progressbar/router";
import {ThemeService} from "./core/service/theme.service";
import {LanguageService} from './core/i18n/language.service';
import {HandoffService} from './core/handoff/handoff.service';
import {holdBootPreloaderUntilFirstNavigation} from './core/boot/boot-preloader';
import {warmUpInitialRoute} from './core/boot/route-warmup';
import {readShellHint} from './core/boot/shell-hint';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [
    RouterOutlet,
    ImagePreviewModalComponent,
    NgProgressbar,
    NgProgressRouter,
]
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'guide-glare';
    previewData: ImagePreviewData | null = null;
    private previewSubscription: Subscription;

    constructor(versionCheck: VersionCheckService, discountService: DiscountService, private imagePreviewService: ImagePreviewService, router: Router) {
        // Eager singletony: ThemeService nastaví data-theme; LanguageService spustí stahování
        // překladů hned teď, souběžně s obnovou Firebase session v guardech — jinak by vznikl
        // až s LayoutContainerComponent a popisky by doskakovaly po vykreslení layoutu.
        inject(ThemeService);
        inject(LanguageService);

        // Handoff z prodejního webu: cookie gg_handoff / ?gg= se čte před první navigací, aby parametr
        // nepřežil do returnUrl a cookie nezůstala viset přes login. Spotřeba běží až po přihlášení
        // (LayoutContainerComponent, SubscriptionAwaitComponent), tady se jen odloží.
        inject(HandoffService).capture();

        // Konstruktor běží před startem první navigace (enabledNonBlocking): boot preloader
        // z index.html drží do jejího konce a chunk dashboardu se stahuje paralelně s guardy.
        holdBootPreloaderUntilFirstNavigation(router);
        void warmUpInitialRoute(location.pathname, readShellHint());
    }

    ngOnInit(): void {
        this.previewSubscription = this.imagePreviewService.previewState$.subscribe(data => {
            this.previewData = data;
        });
    }

    ngOnDestroy(): void {
        if (this.previewSubscription) {
            this.previewSubscription.unsubscribe();
        }
    }

    closeImagePreview(): void {
        this.imagePreviewService.close();
    }
}
